module.exports = __webpack_public_path__ + "static/media/(V)_MG_5752_-_Cia_Termal_Beachewear_-_Moda_Feminina_-_Acessorios.694c2fc1.jpg";